<template lang="pug">
	div
		h3 Delivery and format options

		p: b Digital Reports

		.checkout-item
			.description
				b-form-checkbox( v-model='products[sku.email].checked', id='email', @change='checkDelivSoftRules($event, sku.email)')
				label(for='email') Standard e-mail delivery: 8½" x 11" report in PDF format
			.cost No extra charge

		.checkout-item(v-if='showFormatOpt')
			.description
				b-form-checkbox( v-model='products[sku.email1r].checked', id='email1r', @change='checkDelivSoftRules($event, sku.email1r)')
				label(for='email1r') I need the important pages (Forms CF-1R &amp MF-1R) as files ready for large format plotting, or placing in a CAD document.
			.cost Add $ {{ products[sku.email1r].price }}

		.checkout-item(v-if='showFormatOpt')
			.description
				.spacing-ls
					| Standard arrangement for placement within a CAD drawing: <br />
					b-form-radio-group(v-model='chkOpt.delivery.softCopyArrange', @change='checkDelivSoftRules($event, "softCopyArrange")')
						b-form-radio(id='811', value='811')
						label(for='811') Individual 8&frac12" x 11" pages in JPEG Format
						br
						b-form-radio(id='2522', value='2522')
						label(for='2522') 25&frac12" x 22" block
						br
						.spacing-ls
							| Select Format: <br />
							b-form-radio-group(v-model='chkOpt.delivery.softStandardFormat', @change='checkDelivSoftRules($event, "softStandardFormat")')
								b-form-radio(id='PDF', value='PDF')
								label(for='PDF') PDF
								br
								b-form-radio(id='EPS', value='EPS')
								label(for='EPS') EPS
						p
							| Full sheet with easyTitle24.com title block in PDF Format: <br />
							b-form-radio(id='1824', value='1824')
							label(for='1824') 18" x 24"
							br
							b-form-radio(id='2436', value='2436')
							label(for='2436') 24" x 36"
							br
							b-form-radio(id='3042', value='3042')
							label(for='3042') 30" x 42"

		p: b Printed Reports

		.checkout-item
			.description
				b-form-checkbox(v-model='products[sku.hardCopy].checked', id='hardCopy', @change='checkDelivHardRules($event, sku.hardCopy)')
				label(for='hardCopy') Hard copy delivered through priority mail (allow 3 business days for delivery)
			.cost Add $ {{ products[sku.hardCopy].price }}

		.checkout-item
			.description
				.spacing-ls
					| Send me &nbsp;
					input(type='number', min='0', v-model='chkOpt.delivery.hardCopyAddtnl', @change='checkDelivHardRules($event, "hardCopyAddtnl")')
					| &nbsp; additional copies at $ {{ products[sku.hardCopyAddtnl].price }} each
					br
					p
						| Mail to:
						br
						b-form-radio-group(v-model='chkOpt.delivery.hardCopyShipto', @change='checkDelivHardRules($event,"hardCopyShipto")')
							b-form-radio#BO(name='hardCopyShipto', value='BO')
							label(for='BO') Billing Address
							br
							b-form-radio#DM(name='hardCopyShipto', value='DM')
							label(for='DM') Decision Maker
							br
							b-form-radio#SG(name='hardCopyShipto', value='SG')
							label(for='SG') Report Signer
							br
							b-form-radio#SO(name='hardCopyShipto', value='SO')
							label(for='SO') Other Mailing Address

		.checkout-item(v-if='showFormatOpt')
			.description
				.spacing-ls
					b-form-checkbox( v-model='products[sku.hardCopy1r].checked', id='hardCopy1r', @input='checkDelivHardRules($event,sku.hardCopy1r)')
					label(for='hardCopy1r') I need the important report pages (Forms CF-1R &amp MF-1R) on a reproducible physical plan sheet.  Specify size:
					.spacing-ls
						b-form-radio-group(v-model='chkOpt.delivery.hardCopySize', @input='checkDelivHardRules($event, "hardCopySize")')
							b-form-radio(id='hcs1824', name='hardCopySize', value='1824')
							label(for='hcs1824') 18" x 24"
							br
							b-form-radio(id='hcs2436', name='hardCopySize', value='2436')
							label(for='hcs2436') 24" x 36"
							br
							b-form-radio(id='hcs3042', name='hardCopySize', value='3042')
							label(for='hcs3042') 30" x 42"
			.cost Add $ {{ products[sku.hardCopy1r].price }}

		.div-container-right
			a(@click="previous")
				easyBtn(btnText="Previous")

			a(@click="next")
				easyBtn(btnText="Next")

</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import store from 'CommonApp/store'
import {Person, PhoneNumber, EmailAddress, PostalAddress} from 'janux-people'
import easyBtn from 'Common/components/easy-btn.vue'

export default {
	name: 'checkout-delivery',
	props: ['project', 'products', 'sku', 'chkOpt', 'contacts'],
	components: { easyBtn },
	data () {
		return {
			loadPrj: null
		}
	},
	created () {
		console.log('created delivery component!!')
		// Load project
		Vue.e24.projectService.findOneById(this.project.projId).then((project) => {
			this.loadPrj = project
			this.products[this.sku.email].checked = true 	// Default delivery email option
			// Find project billing contact (BO)
			Vue.e24.contactService.findContactByProjIdAndType(this.project.projId, 'BO').then((prjBillAddr) => {
				this.contacts.length = 0

				if (_.isNil(prjBillAddr)) {
					// Add a project's billing address based on default user contact
					let projectBilling = _.clone(Vue.e24.security.currentUser.contact)
					delete projectBilling.contactId	// Delete contact id in order to insert as new contact
					projectBilling.typeId = 'BO'
					projectBilling.projId = this.project.projId
					projectBilling.userId = Vue.e24.security.currentUser.userId
					console.log('Billing address NOT found for this project, using user default', projectBilling)
					this.setContact('Billing address', projectBilling)
				} else {
					console.log('Billing address found for this project', prjBillAddr)
					prjBillAddr.projId = this.project.projId
					this.setContact('Billing address', prjBillAddr)
				}

				if (this.chkOpt.delivery.hardCopyShipto) {
					this.checkDelivHardRules(this.chkOpt.delivery.hardCopyShipto, 'hardCopyShipto')
				}
			})
		})
	},
	computed: {
		// only display formatting options
		// if the Customer is requesting for a full report
		showFormatOpt () {
			return this.products[this.sku.report].checked
		}
	},
	methods: {
		setContact (title, object) {
			this.contacts.push({title, object})
		},

		createEmptyContact (typeId) {
			let emptyContactObj = new Person('', '', '', '', '', '')
			emptyContactObj.setContactMethod('WORK', new PhoneNumber())
			emptyContactObj.setContactMethod('WORK', new EmailAddress())
			emptyContactObj.setContactMethod('WORK', new PostalAddress())
			emptyContactObj.typeId = typeId
			emptyContactObj.projId = this.project.projId
			emptyContactObj.userId = Vue.e24.security.currentUser.userId
			return emptyContactObj
		},
		// check to see whether we need to display a mailing address
		setMailingAddress () {
			let shipToId = this.chkOpt.delivery.hardCopyShipto
			let head = ''

			// Erase last shipping contact
			if (this.contacts.length > 1) {
				this.contacts.pop()
			}

			if (shipToId !== '' && shipToId !== 'BO') {
				// Define address label
				switch (shipToId) {
				case 'SG': // mail to report signer
					head = 'Mailing Address:  Report Signer'
					break

				case 'DM': // mail to decision maker
					head = 'Mailing Address:  Decision Maker'
					if (this.loadPrj.sgnrIsDcsnMkr) {
						console.log('Mailing address set to DM but for this project SG is DM')
						shipToId = 'SG'
					}
					break

				case 'SO': // mail to an 'other' mailing address
					head = 'Mailing Address'
					break
				}

				Vue.e24.contactService.findContactByProjIdAndType(this.project.projId, shipToId).then((prjShipAddr) => {
					if (_.isNil(prjShipAddr)) {
						if (shipToId === 'SO') {
							const emptyContactObj = this.createEmptyContact('SO')
							this.setContact(head, emptyContactObj)
							console.log('Shipping address not found, creating a new one', emptyContactObj)
						} else {
							console.error('Unable to find shipping address for this project, type selected', shipToId)
						}
					} else {
						console.log('Shipping address found for this project, type', shipToId, 'object', prjShipAddr)
						this.setContact(head, prjShipAddr)
					}
				})
			}
		},
		// anElement can be a product sku or a product suboption
		checkDelivHardRules (value, anElement) {
			// Is a product?
			if (!_.isNil(this.products[anElement])) {
				if (value === false) {
					console.log('product NOT checked', value, anElement, this.products[anElement])
					// if the hard option is unchecked, uncheck all options below
					if (anElement === this.sku.hardCopy) {
						this.chkOpt.delivery.hardCopyAddtnl = ''
						this.chkOpt.delivery.hardCopyShipto = ''

						this.products[this.sku.hardCopy1r].checked = false
						this.chkOpt.delivery.hardCopySize = ''
						this.setMailingAddress()
					}

					// if the hard 1R option is unchecked, uncheck the size options
					if (anElement === this.sku.hardCopy1r) {
						this.chkOpt.delivery.hardCopySize = ''
					}
				} else if (value === true) {
					console.log('product checked', value, anElement, this.products[anElement])
					// if the hard copy report is selected
					// default shipto to Report Signer
					if (anElement === this.sku.hardCopy) {
						this.chkOpt.delivery.hardCopyShipto = 'BO'
					}

					// if the 1R box is checked, check hard-copy and
					// set appropriate shipping and size defaults
					if (anElement === this.sku.hardCopy1r) {
						if (this.chkOpt.delivery.hardCopySize === '') {
							this.chkOpt.delivery.hardCopySize = '2436'
						}
						if (this.chkOpt.delivery.hardCopyShipto === '') {
							this.chkOpt.delivery.hardCopyShipto = 'BO'
						}
						this.products[this.sku.hardCopy].checked = true
					}
				}
			} else {
				console.log('product option', anElement)
				// The following only applies if  anElement is a
				// product option (not a product itself)
				switch (anElement) {
				// if a shipto is selected, check the hard copy checkbox
				case 'hardCopyShipto':
					this.products[this.sku.hardCopy].checked = true
					this.chkOpt.delivery.hardCopyShipto = value
					this.setMailingAddress()
					break

				// if one of the hard1R size radio is checked,
				// check the Hard Copy Delivery and 1R checkboxes
				case 'hardCopySize':
					if (this.chkOpt.delivery.hardCopyShipto === '') {
						this.chkOpt.delivery.hardCopyShipto = 'BO'
					}
					this.products[this.sku.hardCopy].checked = true
					this.products[this.sku.hardCopy1r].checked = true
					break

				// if additional hard copies are selected,
				// validate the value entered and check the hard copy checkbox
				case 'hardCopyAddtnl':
					if (this.chkOpt.delivery.hardCopyAddtnl === '0') {
						this.chkOpt.delivery.hardCopyAddtnl = ''
					} else {
						this.products[this.sku.hardCopy].checked = true
						this.chkOpt.delivery.hardCopyShipto = 'BO'
					}
					break
				}
			}
		},
		// anElement can be a product sku or a product suboption label
		checkDelivSoftRules (value, anElement) {
			// Is a product?
			if (!_.isNil(this.products[anElement])) {
				if (value === false) {
					// if the softReport or soft 1R checkboxes are unchecked, uncheck all the options
					// only do this if we are dealing with a full report that has a 1R option
					if (anElement === this.sku.email || anElement === this.sku.email1r) {
						this.products[this.sku.email1r].checked = false
						this.chkOpt.delivery.softCopyArrange = ''
						this.chkOpt.delivery.softStandardFormat = ''
					}
				}

				if (value === true) {
					// if the soft1R checkbox is selected,
					// select the soft report checkbox,
					// and select appropriate default values

					if (anElement === this.sku.email1r) {
						this.products[this.sku.email].checked = true
						this.chkOpt.delivery.softCopyArrange = '2436'
					}
				}
			} else {
				// if one of the soft1R options radio is checked,
				// check the Standard Delivery and the 1R checkboxes
				if (anElement === 'softCopyArrange') {
					if (this.chkOpt.delivery.softCopyArrange === '811' || this.chkOpt.delivery.softCopyArrange === '2522') {
						// set appropriate standard format defaults, if none selected
						if (this.chkOpt.delivery.softStandardFormat === '') {
							this.chkOpt.delivery.softStandardFormat = 'PDF'
						}
					} else {
						this.chkOpt.delivery.softStandardFormat = ''
					}
					this.products[this.sku.email].checked = true
					this.products[this.sku.email1r].checked = true
				}

				// if one of the radios for standard arrange is checked
				// uncheck the standard arrange radios, default to the top full arrange
				// and check the Standard delivery and 1R checkboxes
				if (anElement === 'softStandardFormat') {
					if (this.chkOpt.delivery.softCopyArrange === '') {
						this.chkOpt.delivery.softCopyArrange = '811'
						this.products[this.sku.email].checked = true
						this.products[this.sku.email1r].checked = true
					}
				}
			}
		},
		next () {
			// if (this.products[this.sku.hardCopy].checked) {
			//	if (!this.chkOpt.delivery.hardCopyAddtnl) {
			//		this.$notify({
			//			group: 'app',
			//			type: 'error',
			//			title: 'Additional copies',
			//			text: 'Please enter a valid additional copies',
			//			duration: 5000
			//		})
			//		return;
			//	}
			// }

			// Add options to products if selected
			if (this.products[this.sku.email1r].checked) {
				this.products[this.sku.email1r].options = {
					softCopyArrange: this.chkOpt.delivery.softCopyArrange,
					softStandardFormat: this.chkOpt.delivery.softStandardFormat
				}
			}

			if (this.products[this.sku.hardCopy1r].checked) {
				this.products[this.sku.hardCopy1r].options = {
					hardCopySize: this.chkOpt.delivery.hardCopySize
				}

				if (this.chkOpt.delivery.hardCopyAddtnl && this.chkOpt.delivery.hardCopyAddtnl > 0) {
					this.products[this.sku.hardCopyAddtnl].checked = true
					this.products[this.sku.hardCopyAddtnl].quantity = this.chkOpt.delivery.hardCopyAddtnl
				}
			}

			// Goto billing form tab
			store.dispatch({
				type: 'changeCheckoutActiveTab',
				value: 'tab-billing-data'
			})
		},
		previous () {
			// Goto billing form tab
			store.dispatch({
				type: 'changeCheckoutActiveTab',
				value: 'tab-report-options'
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/checkout/tabs-components/delivery.vue